import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { hr } from '../../face/hrApi';
import EnrolModal from './EnrolModal';

const initials = (n) => (n || '??').trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase();
const colour = (n) => { const c = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#06b6d4', '#f97316']; let h = 0; for (const ch of n || '') h += ch.charCodeAt(0); return c[h % c.length]; };

export default function FaceEnrolTab({ configured, onChanged }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  const [filter, setFilter] = useState('all'); // all | enrolled | missing
  const [err, setErr] = useState('');
  const [target, setTarget] = useState(null);

  const load = useCallback(async () => {
    try { setRows((await hr('/enrolment')).employees); setErr(''); } catch (e) { setErr(e.message); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const remove = async (e) => {
    if (!window.confirm(`Remove the face data for ${e.full_name}? They will have to be enrolled again to use the kiosk.`)) return;
    try { await hr(`/enroll/${e.id}`, { method: 'DELETE' }); await load(); onChanged && onChanged(); } catch (ex) { setErr(ex.message); }
  };

  const shown = useMemo(() => {
    if (!rows) return [];
    const s = q.trim().toLowerCase();
    return rows.filter((r) => {
      if (filter === 'enrolled' && !r.samples) return false;
      if (filter === 'missing' && r.samples) return false;
      return !s || `${r.full_name} ${r.code} ${r.department || ''}`.toLowerCase().includes(s);
    });
  }, [rows, q, filter]);
  const enrolled = rows ? rows.filter((r) => r.samples > 0).length : 0;

  return (
    <div className="fc-card">
      <div className="fc-toolbar">
        <h3>Enrolment <span className="fc-muted fc-small">{rows ? `${enrolled} of ${rows.length} enrolled` : ''}</span></h3>
        <input className="fc-search" placeholder="Search name, ID or department" value={q} onChange={(e) => setQ(e.target.value)} />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">Everyone</option><option value="enrolled">Enrolled</option><option value="missing">Not enrolled</option>
        </select>
      </div>
      <p className="fc-muted">Enrol each person on the kiosk device or any laptop with a camera: five quick poses, about 30 seconds. Only an encrypted face template is kept — no photo of the enrolment is stored.</p>
      {err && <div className="fc-callout fc-bad">{err}</div>}
      {!rows ? <div className="fc-muted">Loading…</div> : (
        <div className="fc-list">
          {shown.map((r) => (
            <div className="fc-row" key={r.id}>
              <div className="fc-av" style={{ background: colour(r.full_name) }}>{initials(r.full_name)}</div>
              <div className="fc-row-main">
                <div className="fc-row-name">{r.full_name} <span className="fc-muted fc-small">{r.code}</span></div>
                <div className="fc-muted fc-small">{[r.department, r.location_name || r.city].filter(Boolean).join(' · ') || '—'}</div>
              </div>
              <span className={`fc-pill ${r.samples ? 'fc-pill-ok' : 'fc-pill-off'}`}>{r.samples ? `Enrolled · ${r.samples} samples` : 'Not enrolled'}</span>
              <button className="fc-btn fc-btn-sm fc-btn-red" disabled={!configured} onClick={() => setTarget(r)}>{r.samples ? 'Re-enrol' : 'Enrol'}</button>
              {r.samples > 0 && <button className="fc-btn fc-btn-sm fc-btn-ghost" onClick={() => remove(r)}>Remove</button>}
            </div>
          ))}
          {shown.length === 0 && <div className="fc-muted">No one matches.</div>}
        </div>
      )}
      {target && <EnrolModal employee={target} onClose={() => { setTarget(null); load(); onChanged && onChanged(); }} />}
    </div>
  );
}
